import { c as _c } from "react/compiler-runtime";
import { cn } from '@/shared/lib/utils';
export function SectionHeader(t0) {
  const $ = _c(10);
  const {
    title,
    description,
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("container space-y-6 py-16 text-center md:py-24", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== title) {
    t2 = <h2 className="text-center text-4xl font-semibold lg:text-5xl">{title}</h2>;
    $[2] = title;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== description) {
    t3 = <p>{description}</p>;
    $[4] = description;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t1 || $[7] !== t2 || $[8] !== t3) {
    t4 = <div className={t1}>{t2}{t3}</div>;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
}